import React from "react";
import Banner from "../../components/Banner";
import Footer from "../../components/Footer";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import FlagAsset from "./flag";
import ChangeOwnership from "./changeOwnership";
import Deregister from "./deregister";
import Recovered from "./recovered";
import UpdateStatus from "./updateStatus";
import { Modal } from "../../components/Modal";
import UpdateBack from "./updateBack";
import ChangeOwnershipFinalise from "./changeOwnershipFinalise";
import AssetView from "./assetView";

const API = localStorage.getItem("assethost");

export default class AssetsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      valid: true,
      msg: "",
      toastColor: "",
      assets: [],
      category: "",
      uniqueIdentifier: "",
      status: "",
      categories: [],
      statuses: [],
      page: 0,
      size: 10,
      totalPages: 1,
      profileId: 0,
      companyProfileId: sessionStorage.getItem("companyProfileId") || "0",
      isIndividual: false,
      errors: {},

      showFlagModal: false,
      showChangeOwnershipModal: false,
      showDeregisterModal: false,
      showRecoveredModal: false,
      showUpdateStatusModal: false,
      showAcceptChangeModal: false,
      showChangeOwnershipFinaliseModal: false,
      showUpdateBackModal: false,
      showAssetViewModal: false,
      currentAssetId: "",
      currentAssetType: "",
      currentPrimaryName: "",
      currentSecondaryName: "",      
      currentUniqueIdentifier: "",
      currentCategoryName: "",
      currentSubCategoryName: "",
      assetIdToChange: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.validateSearch = this.validateSearch.bind(this);
    this.fetchDropdowns = this.fetchDropdowns.bind(this);
    this.fetchAssets = this.fetchAssets.bind(this);
    this.loadProfileId = this.loadProfileId.bind(this);
    this.handleChangeOwnershipFinalise =
      this.handleChangeOwnershipFinalise.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.loadProfileId();
    this.fetchDropdowns(token);
    this.fetchAssets(token);
  }

  loadProfileId() {
    const individualProfileId = parseInt(
      sessionStorage.getItem("individualProfileId") || "0"
    );
    const companyProfileId = parseInt(
      sessionStorage.getItem("companyProfileId") || "0"
    );
    if (individualProfileId > 0) {
      this.setState({ profileId: individualProfileId, isIndividual: true });
    } else if (companyProfileId > 0) {
      this.setState({ profileId: companyProfileId, isIndividual: false });
    } else {
      this.setState({
        loading: false,
        msg: "No Profile Found",
        toastColor: "danger",
      });
    }
  }

  fetchDropdowns(token) {
    axios
      .get(API + "/asset/getassetsearchdropdownlist", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        this.setState({
          categories: data.categories || [],
          statuses: data.assetStatuss || [],
          loading: false,
        });
        if (this.state.profileId > 0) {
          let request = {};
          if (Number(this.state.profileId)) {
            if (this.state.isIndividual) {
              request.individualProfileId = this.state.profileId;
            } else {
              request.companyProfileId = this.state.profileId;
            }
          }
          if (this.state.category) {
            request.categoryName = this.state.category;
          }
          if (this.state.uniqueIdentifier) {
            request.uniqueIdentifier = this.state.uniqueIdentifier;
          }
          this.fetchAssets(token, undefined, request);
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load dropdowns.",
          toastColor: "danger",
        });
      });
  }

  fetchAssets(token, page = 0, request) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    let body = {
      individualProfileId: this.state.isIndividual ? this.state.profileId : 0,
      companyProfileId: !this.state.isIndividual ? this.state.profileId : 0,
    };
    if (this.state.status) {
      body.assetStatus = this.state.status;
    }
    if (this.state.category) {
      body.categoryName = this.state.category;
    }
    if (this.state.uniqueIdentifier) {
      body.uniqueIdentifier = this.state.uniqueIdentifier;
    }
    axios
      .post(API + "/asset/getallassetbyrefid", request ? request : body, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let assets = [];
        let totalPages = 1;
        if (Array.isArray(response.data)) {
          assets = response.data;
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          assets = response.data.content;
          totalPages = response.data.totalPages || 1;
        }
        this.setState({
          assets,
          page,
          totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          assets: [],
          totalPages: 1,
          loading: false,
          msg: error?.response?.data?.message || "Failed to load assets.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  validateSearch() {
    // const s = this.state;
    let errors = {};
    let valid = true;
    // if (!s.category && !s.uniqueIdentifier && !s.status) {
    //   errors.search = "At least one filter is required";
    //   valid = false;
    // }
    this.setState({ errors, valid });
    return valid;
  }

  handleSearch(e) {
    if (e) e.preventDefault();
    if (!this.validateSearch()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.fetchAssets(token, 0);
  }

  handlePreviousPage() {
    if (this.state.page > 0) {
      const token = sessionStorage.getItem("token");
      if (!token) {
        this.setState({
          loading: false,
          msg: "No User Token",
          toastColor: "danger",
        });
        sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
        return;
      }
      this.fetchAssets(token, this.state.page - 1);
    }
  }

  handleNextPage() {
    if (this.state.page + 1 < this.state.totalPages) {
      const token = sessionStorage.getItem("token");
      if (!token) {
        this.setState({
          loading: false,
          msg: "No User Token",
          toastColor: "danger",
        });
        sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
        return;
      }
      this.fetchAssets(token, this.state.page + 1);
    }
  }

  handleChangeOwnershipFinalise() {
    this.setState({ showChangeOwnershipFinaliseModal: true, showAcceptChangeModal: false });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    const rowButtons = (asset) => {
      const flag =
        asset?.primaryStatus?.toUpperCase() === "NOT_AUTHORISED_FOR_SALE" ? (
          <button
            key={`flag-action-clickable`}
            className="clickable-text"
            onClick={() =>
              this.setState({
                showFlagModal: true,
                currentAssetId: asset.id,
                currentAssetType: asset.assetType,
                 currentSecondaryName: asset.secondaryName,
                currentPrimaryName: asset.primaryName,
                currentUniqueIdentifier: asset.uniqueIdentifier,
              })
            }
          >
            Flag
          </button>
        ) : null;
      const update =
        asset?.primaryStatus?.toUpperCase() === "NOT_AUTHORISED_FOR_SALE" ? (
          <button
            key={`update-status-action-clickable`}
            className="clickable-text"
            onClick={() =>
              this.setState({
                showUpdateStatusModal: true,
                currentAssetId: asset.id,
                currentAssetType: asset.assetType,
                 currentSecondaryName: asset.secondaryName,
                currentPrimaryName: asset.primaryName,
                currentUniqueIdentifier: asset.uniqueIdentifier,
              })
            }
          >
            Update Status
          </button>
        ) : null;
      const transfer =
        asset?.primaryStatus?.toUpperCase() === "NOT_AUTHORISED_FOR_SALE" ? (
          <button
            key={`change-ownership-action-clickable`}
            className="clickable-text"
            onClick={() =>
              this.setState({
                showChangeOwnershipModal: true,
                currentAssetId: asset.id,
                currentAssetType: asset.assetType,
                 currentSecondaryName: asset.secondaryName,
                currentPrimaryName: asset.primaryName,
                currentUniqueIdentifier: asset.uniqueIdentifier,
              })
            }
          >
            Transfer Ownership
          </button>
        ) : null;
      const recovered =
        asset?.primaryStatus?.toUpperCase() === "RECOVERED" ? (
          <button
            key={`recover-action-clickable`}
            className="clickable-text"
            onClick={() =>
              this.setState({
                showRecoveredModal: true,
                currentAssetId: asset.id,
                currentAssetType: asset.assetType,
                currentAssetSecondaryName: asset.secondaryName,
                currentAssetPrimaryName: asset.primaryName,
                currentAssetUniqueIdentier: asset.uniqueIdentifier,
              })
            }
          >
            Recovered
          </button>
        ) : null; 
      const deregister =
        asset?.primaryStatus?.toUpperCase() === "NOT_AUTHORISED_FOR_SALE" ? (
          <button
            key={`deregister-action-clickable`}
            className="clickable-text"
            onClick={() =>
              this.setState({
                showDeregisterModal: true,
                currentAssetId: asset.id,
                currentAssetType: asset.assetType,
                 currentSecondaryName: asset.secondaryName,
                currentPrimaryName: asset.primaryName,
                currentUniqueIdentifier: asset.uniqueIdentifier,
              })
            }
          >
            Deregister
          </button>
        ) : null;
      
      const updateBack =
        (asset?.primaryStatus?.toUpperCase() === "COMPANY_PROPERTY" ||  asset?.primaryStatus?.toUpperCase() === "LEASED" ||  asset?.primaryStatus?.toUpperCase() === "LOAN" ||  asset?.primaryStatus?.toUpperCase() === "ON_HIRE_PURCHASE" )? (
          <button
            key={`deregister-action-clickable`}
            className="clickable-text"
            onClick={() =>
              this.setState({
                showUpdateBackModal: true,
                currentAssetId: asset.id,
                currentAssetType: asset.assetType,
                currentSecondaryName: asset.secondaryName,
                currentPrimaryName: asset.primaryName,
                currentUniqueIdentifier: asset.uniqueIdentifier,
              })
            }
          >
            Update Status
          </button>
        ) : null; 

      const assetView =
        asset?.primaryStatus?.toUpperCase() !== "DEREGISTERED" ? (
          <button
            key={`deregister-action-clickable`}
            className="clickable-text"
            onClick={() =>
              this.setState({
                showAssetViewModal: true,
                currentAssetId: asset.id,
                currentCategoryName: asset.categoryName,
                currentSubCategoryName: asset.subCategoryName,
                 currentSecondaryName: asset.secondaryName,
                currentPrimaryName: asset.primaryName,
                currentUniqueIdentifier: asset.uniqueIdentifier,
              })
            }
          >
            Asset View
          </button>
        ) : null;
      const buttons = [flag, update, recovered, transfer, deregister, updateBack, assetView];

      return (
        <div className="flex gap-1">
          {buttons?.length &&
            buttons.map((buttonNode, index) => (
              <>
                {buttonNode}
                {index + 1 < buttons?.length && buttonNode && (
                  <div
                    key={`divider-for-action-${index}`}
                    className="v-divider"
                  ></div>
                )}
              </>
            ))}
        </div>
      );
    };

    return (
      <div className="min-h-screen flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title="Assets" />
          {divMsg}
          <div className="w-full grow px-5 flex flex-col items-center justify-start">
            <div className="flex gap-4 mt-2 mb-2 w-full justify-start">
              <a href="/asset/register" className="btn btn-success">
                Register
              </a>
              {s.companyProfileId > 0 && (
                <a href="/asset/bulk-upload" className="btn btn-success">
                  Bulk Upload
                </a>
              )}
              <button
                className="btn btn-success"
                onClick={() => this.handleChangeOwnershipFinalise()}
              >
                Accept Ownership
              </button>
            </div>
            <form
              className="flex gap-4 mb-4 w-full"
              autoComplete="off"
              onSubmit={this.handleSearch}
            >
              <div className="input-group !w-fit">
                <label className="input-group-text !w-fit">Category</label>
                <select
                  name="category"
                  className="form-control"
                  value={s.category}
                  onChange={this.handleChange}
                >
                  <option value="">Select</option>
                  {s.categories.map((cat, index) => (
                    <option key={`category-${index}`} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
                {s.errors.category && (
                  <span className="input-group-error">{s.errors.category}</span>
                )}
              </div>
              <div className="input-group !w-fit">
                <label className="input-group-text !w-fit">
                  Unique Identifier
                </label>
                <input
                  name="uniqueIdentifier"
                  className="form-control"
                  type="text"
                  value={s.uniqueIdentifier}
                  onChange={this.handleChange}
                />
                {s.errors.uniqueIdentifier && (
                  <span className="input-group-error">
                    {s.errors.uniqueIdentifier}
                  </span>
                )}
              </div>
              <div className="input-group !w-fit">
                <label className="input-group-text !w-fit">Status</label>
                <select
                  name="status"
                  className="form-control"
                  value={s.status}
                  onChange={this.handleChange}
                >
                  <option value="">Select</option>
                  {s.statuses.map((stat, index) => (
                    <option key={`asset-status-${index}`} value={stat}>
                      {stat}
                    </option>
                  ))}
                </select>
                {s.errors.status && (
                  <span className="input-group-error">{s.errors.status}</span>
                )}
              </div>
              <button type="submit" className="btn btn-success ml-auto">
                Search
              </button>
            </form>
            <div className="w-full overflow-x-auto border">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Asset Number
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Category
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Sub Category
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Unique Identifier
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200 overflow-y-auto">
                  {s.assets.map((asset) => (
                    <tr key={`asset-${asset.id}`} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {asset.assetNumber}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {asset.categoryName}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {asset.subCategoryName}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {asset.primaryName}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {asset.uniqueIdentifier}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {asset.primaryStatus}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        {rowButtons(asset)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {s.assets.length === 0 && (
                <div className="text-gray-500 text-center py-4">
                  No assets found.
                </div>
              )}
            </div>
            {s.totalPages > 1 && (
              <div className="flex justify-center items-center gap-2 mt-4">
                <button
                  className="btn btn-outline"
                  disabled={s.page === 0}
                  onClick={this.handlePreviousPage}
                >
                  Previous
                </button>
                <span>
                  Page {s.page + 1} of {s.totalPages}
                </span>
                <button
                  className="btn btn-outline"
                  disabled={s.page + 1 >= s.totalPages}
                  onClick={this.handleNextPage}
                >
                  Next
                </button>
              </div>
            )}
          </div>
          <Footer />
        </div>
        {s.showFlagModal && (
          <FlagAsset
            key={`flag-asset-${s.currentAssetId}`}
            closeAction={() => this.setState({ showFlagModal: false })}
            assetId={s.currentAssetId}
            assetType={s.currentAssetType}
            assetBrand={s.currentPrimaryName}
            assetModel={s.currentSecondaryName}
            assetUniqueIdentier={s.currentUniqueIdentifier}
            onSuccess={() => {
              this.setState({ showFlagModal: false });
              this.fetchAssets(
                sessionStorage.getItem("token"),
                this.state.page
              );
            }}
          />
        )}
        {s.showChangeOwnershipModal && (
          <ChangeOwnership
            key={`change-ownership-for-asset-${s.currentAssetId}`}
            closeAction={() =>
              this.setState({ showChangeOwnershipModal: false })
            }
            assetId={s.currentAssetId}
            assetType={s.currentAssetType}
            assetBrand={s.currentPrimaryName}
            assetModel={s.currentSecondaryName}
            assetUniqueIdentier={s.currentUniqueIdentifier}
            onSuccess={() => {
              this.setState({ showRecoveredModal: false });
              this.fetchAssets(
                sessionStorage.getItem("token"),
                this.state.page
              );
            }}
          />
        )}
        {s.showAssetViewModal && (
          <AssetView
            key={`view-asset-${s.currentAssetId}`}
            closeAction={() => this.setState({ showAssetViewModal: false })}
            assetId={s.currentAssetId}
            assetType={s.currentAssetType}
            primaryName={s.currentPrimaryName}
            secondaryName={s.currentSecondaryName}
            uniqueIdentifier={s.currentUniqueIdentifier}
            subCategoryName={s.currentSubCategoryName}
            categoryName={s.currentCategoryName}
            onSuccess={() => {
              this.setState({ showAssetViewModal: false });
              this.fetchAssets(
                sessionStorage.getItem("token"),
                this.state.page
              );
            }}
          />
        )}
        {s.showUpdateBackModal && (
          <UpdateBack
            key={`updateback-asset-${s.currentAssetId}`}
            closeAction={() => this.setState({ showUpdateBackModal: false })}
            assetId={s.currentAssetId}
            assetType={s.currentAssetType}
            assetBrand={s.currentPrimaryName}
            assetModel={s.currentSecondaryName}
            assetUniqueIdentier={s.currentUniqueIdentifier}
            onSuccess={() => {
              this.setState({ showUpdateBackModal: false });
              this.fetchAssets(
                sessionStorage.getItem("token"),
                this.state.page
              );
            }}
          />
        )}
        {s.showDeregisterModal && (
          <Deregister
            key={`deregister-asset-${s.currentAssetId}`}
            closeAction={() => this.setState({ showDeregisterModal: false })}
            assetId={s.currentAssetId}
            assetType={s.currentAssetType}
            assetBrand={s.currentPrimaryName}
            assetModel={s.currentSecondaryName}
            assetUniqueIdentier={s.currentUniqueIdentifier}
            onSuccess={() => {
              this.setState({ showDeregisterModal: false });
              this.fetchAssets(
                sessionStorage.getItem("token"),
                this.state.page
              );
            }}
          />
        )}
        {s.showRecoveredModal && (
          <Recovered
            key={`recover-asset-${s.currentAssetId}`}
            closeAction={() => this.setState({ showRecoveredModal: false })}
            assetId={s.currentAssetId}
            assetType={s.currentAssetType}
            assetBrand={s.currentPrimaryName}
            assetModel={s.currentSecondaryName}
            assetUniqueIdentier={s.currentUniqueIdentifier}
            onSuccess={() => {
              this.setState({ showRecoveredModal: false });
              this.fetchAssets(
                sessionStorage.getItem("token"),
                this.state.page
              );
            }}
          />
        )}
        {s.showUpdateStatusModal && (
          <UpdateStatus
            key={`update-status-for-asset-${s.currentAssetId}`}
            closeAction={() => this.setState({ showUpdateStatusModal: false })}
            assetId={s.currentAssetId}
            assetType={s.currentAssetType}
            assetBrand={s.currentPrimaryName}
            assetModel={s.currentSecondaryName}
            assetUniqueIdentier={s.currentUniqueIdentifier}
            onSuccess={() => {
              this.setState({ showUpdateStatusModal: false });
              this.fetchAssets(
                sessionStorage.getItem("token"),
                this.state.page
              );
            }}
          />
        )}
        {s.showAcceptChangeModal && (
          <Modal
            title="Accept asset change ownership"
            closeAction={() =>
              this.setState({ showPopModal: false, popFile: null })
            }
            footerContent={
              <>
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={s.loading || !s.assetIdToChange}
                  onClick={this.handleChangeOwnershipFinalise}
                >
                  Begin
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() =>
                    this.setState({
                      showAcceptChangeModal: false,
                    })
                  }
                >
                  Cancel
                </button>
              </>
            }
          >
            <div className="row">
              <div className="col">
                <div className="input-group">
                  <label className="input-group-text">Asset ID</label>
                  <input
                    name="assetIdToChange"
                    className={`form-control ${
                      s.errors.assetIdToChange ? " !border-red-500" : ""
                    }`}
                    value={s.assetIdToChange}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.assetIdToChange && (
                    <span className="input-group-error">
                      {s.errors.assetIdToChange}
                    </span>
                  )}
                </div>
              </div>
              <div className="col"></div>
            </div>
          </Modal>
        )}
        {s.showChangeOwnershipFinaliseModal && (
          <ChangeOwnershipFinalise
            key={`change-ownership-finalise-${s.assetIdToChange}`}
            closeAction={() =>
              this.setState({ showChangeOwnershipFinaliseModal: false })
            }
            assetId={s.assetIdToChange}
            onSuccess={() => {
              this.setState({ showChangeOwnershipFinaliseModal: false });
              this.fetchAssets(
                sessionStorage.getItem("token"),
                this.state.page
              );
            }}
          />
        )}
      </div>
    );
  }
}
